interface ReportingMobileStatProps {
  label: string;
  value: string;
}

export function ReportingMobileStat({
  label,
  value,
}: ReportingMobileStatProps) {
  return (
    <div className="rounded-md border border-neutral-800/70 bg-neutral-950/40 p-2">
      <div className="text-[10px] uppercase tracking-wider text-neutral-500">
        {label}
      </div>
      <div className="mt-0.5 text-sm font-medium tabular-nums text-neutral-200">
        {value}
      </div>
    </div>
  );
}
